import React from 'react';
import styles from './NotFound.module.scss';
import Logo from '../../components/logo/Logo';
import Button from '../../components/button/Button';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <Logo />
      <h1>404</h1>
      <h2>Page not found</h2>
      <h3>The page you are looking for does not exist.</h3>
      <Button
        label='Go to Home'
        onClick={() => navigate('/')}
      />
    </div>
  );
};

export default NotFound;